<template>
  <div class="test-item">
    <div class="test-item-tigan">
      <div v-html="data.questionBody"></div>
    </div>
    <table>
      <tr v-for="(item2,index) in data.modelList">
        <td style="padding: 10px;" v-html="item2.sort+'.'+ item2.questionBody"></td>
        <td style="padding: 10px;"><input type="text" v-if="showAnswer" disabled="disabled"
                                          :value="item2.questionAnswer"/><input v-else type="text" disabled="disabled"
                                                                                value=""/></td>
        <!-- <td style="padding: 10px;">{{data.questionAnswer[index].option}}</td> -->
      </tr>
    </table>
    <div class="test-item-daan" v-if="showAnswer">
      <el-tag size="small" type="success " style="margin-right:1em">答案</el-tag>
      {{data.questionAnswer2}}
    </div>
    <div class="test-item-jiexi" v-if="showResolve">
      <el-tag size="small" type="success " style="margin-right:1em">解析</el-tag>
      <p v-html="data.questionResolve"></p></div>
    <div class="test-item-createtime" v-if="showTimer">创建于：{{data.createTimeStr}}</div>
  </div>
</template>

<script>
  export default {
    name: 'TestItemPair',
    props: {
      data: {
        required: true
      },
      showAnswer: {
        type: Boolean,
        default: true
      },
      showResolve: {
        type: Boolean,
        default: true
      },
      showTimer: {
        type: Boolean,
        default: true
      },
      showSound: {
        type: Boolean,
        default: true
      },
      testIndex: {
        type: Number,
        default: 1
      },
      testPoint: {
        type: Number,
        default: 0
      }
    },
    methods: {
      playSound(val) {
        var audio = document.getElementsByTagName('audio');
        for (var i = 0; i < audio.length; i++) {
          audio[i].pause();
        }
        let player = document.querySelector('#test' + this.data.questionId);
        if (player.paused) {
          player.play();
        } else {
          player.pause();
        }
      }
    },
    created() {
      console.log("ghc1");
      if (this.data.questionSound == '') {
        this.data.questionSound = null;
      }
      //var questionOpt = JSON.parse(decodeURIComponent(this.data.questionOpt)) ;
      //this.data.questionOpt = questionOpt;
      if (this.data.questionAnswer) {
          this.data.questionAnswer = decodeURIComponent(this.data.questionAnswer);
        }
      //	this.data.questionBody = decodeURIComponent(this.data.questionBody);
      if(this.data.questionResolve){
        this.data.questionResolve = decodeURIComponent(this.data.questionResolve);
      }      
      var temp = [];
      for (var i = 0; i < this.data.modelList.length; i++) {
        this.data.modelList[i].questionBody = decodeURIComponent(this.data.modelList[i].questionBody);
        this.data.modelList[i].questionAnswer = decodeURIComponent(this.data.modelList[i].questionAnswer);
        temp.push(decodeURIComponent(this.data.modelList[i].questionAnswer));
      }
      this.data.questionAnswer2 = temp.toString();
      //	console.log(this.data.questionBody)
      if (this.data.questionBody) {
        var questionBody = decodeURIComponent(this.data.questionBody);

        var index = this.testIndex <= 0 ? '' : this.testIndex + '. ';

        //	console.log(index)
        var point = this.testPoint <= 0 ? '' : '（' + this.testPoint + '分）';
        this.data.questionBody = questionBody;
      }
    },
    filters: {
      testTitle(val) {
        return val.sort+"."+val.questionBody;
      }
    }
  };
</script>

<style scoped>

</style>
